<!--Footer Starts-->
<footer>
    <div class="container-fluid d-flex justify-content-center">
        <p class="copyright">
            &copy; {{currentDate | date: 'yyyy'}} <a>eSynCloud</a>
        </p>
    </div>
</footer>
<!--Footer Ends-->
